import React, { useState } from 'react';
import { LINE_STYLES } from '../config';
import './PriceLinesList.css';

const PriceLinesList = ({ priceLines, darkMode, removePriceLine, deleteAllLines }) => {
    const [isPriceListCollapsed, setIsPriceListCollapsed] = useState(false);

    if (priceLines.length === 0) return null;

    return (
        <div className={`ntc-price-lines-container ${darkMode ? 'ntc-price-lines-container-dark' : 'ntc-price-lines-container-light'} ${isPriceListCollapsed ? 'ntc-price-lines-collapsed' : ''}`}>
            <div 
                onClick={() => setIsPriceListCollapsed(!isPriceListCollapsed)}
                className={`ntc-price-lines-header ${darkMode ? 'ntc-price-lines-header-dark' : 'ntc-price-lines-header-light'}`}
            >
                <span>Price Lines ({priceLines.length})</span>
                <div className="ntc-price-lines-controls">
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteAllLines();
                        }}
                        className={`ntc-delete-all-button ${darkMode ? 'ntc-delete-all-button-dark' : 'ntc-delete-all-button-light'}`}
                        title="Delete All Lines"
                    >
                        <svg 
                            width="14" 
                            height="14" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <path d="M3 6h18" />
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                        </svg>
                    </button>
                    <svg 
                        width="12" 
                        height="12" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                        className={`ntc-collapse-icon ${isPriceListCollapsed ? 'ntc-collapse-icon-collapsed' : 'ntc-collapse-icon-expanded'}`}
                    >
                        <path d="M9 18l6-6-6-6" />
                    </svg>
                </div>
            </div>
            <div className={`ntc-price-lines-list ${isPriceListCollapsed ? 'ntc-price-lines-list-collapsed' : 'ntc-price-lines-list-expanded'}`}>
                {priceLines.map(line => (
                    <div 
                        key={line.id}
                        className={`ntc-price-line-item ${line.isProvided ? 'ntc-price-line-item-provided' : ''}`}
                        style={{
                            background: LINE_STYLES[line.type].titleBackgroundColor,
                        }}
                    >
                        <span 
                            className={`ntc-price-line-title ${line.isProvided ? 'ntc-price-line-title-provided' : ''}`}
                            style={{
                                color: LINE_STYLES[line.type].titleColor,
                            }}
                        >
                            {line.title}: {line.price.toFixed(5)}
                            {line.isProvided && ' (provided)'}
                        </span>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                removePriceLine(line.id);
                            }}
                            className={`ntc-delete-button ${darkMode ? 'ntc-delete-button-dark' : 'ntc-delete-button-light'}`}
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PriceLinesList; 